export const localeToDatoLocale = (locale: string) => {
	// transform locale to the format of data (ex: fr-ca -> fr_CA)
	return locale.replace(/-([a-z]{2})$/, (_, p1) => `_${p1.toUpperCase()}`)
}

export const redpimToCorpoLocale = (locale: string) => {
	// transform locale to the format of data (ex: fr-ca -> fr_fr)
	return locale.replace(/-([a-z]{2})$/, (_, p1) => `_${p1.toUpperCase()}`)
}
